// FormerRelationshipsEmpty. Mirrors data-component=
// "former-relationships-empty" from the approved HTML. Shown inside
// the Relationship Workspace when the Former filter is active and
// no ended connections exist.
import type { ReactNode } from 'react';

export function FormerRelationshipsEmpty(): ReactNode {
  return (
    <section
      className="card former-empty"
      data-component="former-relationships-empty"
    >
      <h3>No former connections in this sample</h3>
      <p>Ended connections appear here with their dates and notes.</p>
    </section>
  );
}
